import { API_BASE_URL, SOCKETURL, SOCKET_TRANSPORTS } from "./site_urls";

export const APPLICATION_NAME = "Inside-Rodeo";
export const STORAGE = "RODEO-APP";
export const SELECTED_EVENT_STORAGE = `${APPLICATION_NAME}-Event`;
export const SELECTED_PWA_STORAGE = `${APPLICATION_NAME}-PWA`;
export const APPLICATION_GLOBAL_SLUG = "inside-rodeo";

export const IS_SHOWING_ADD_TO_HOME_SCREEN_IOS = `${APPLICATION_NAME}-IOS`;

export const PER_PAGE = 6;
export const PER_PAGES = 20;

export const WITHOUT_PER_PAGE = 99999;

export const FILE_BASE_PATH = "";
export const APP_VERSION = process.env.REACT_APP_VERSION;
export const APP_STAGE = process.env.REACT_APP_STAGE;

export const DATE_FORMAT = "MM/dd/yyyy";

export const DATE_ALL_FORMAT = {
  DATE_PICKER_FORMAT: "MM/dd/yyyy",
  MOMENT_FORMAT: "MM/DD/yyyy",
};

export const CHAT_DATE_TIME_FORMAT = {
  DISPLAY_DATE_WITH_TIME: "Do MMMM, YYYY hh:mm a",
  DISPLAY_DAY_TIME: "dddd hh:mm a",
};
export const TIME_CONFIG = {
  TIME_FORMAT: "hh:mm a",
  TIME_INTERVALS: 5,
};

export const SOCKET_URL = SOCKETURL;
export { SOCKET_TRANSPORTS };

export const URLS = {
  HOME: "/",
  LOGIN: "/login",
  LOGIN_WITH_EMAIL: "/loginwithemail",
  REGISTRATION: "/registration",
  FORGOT_PASSWORD: "/forgot-password",
  FORGOT_PASSWORD_OTP: "/forgot-password-otp",
  RESET_PASSWORD: "/reset-password/:token",
  TV_IMAGE: "/tv-leaderboard",
  USER: {
    DASHBOARD: "/dashboard",
    PROFILE: "/profile",
  },
  CMS: {
    ABOUT_US: "/cms/about-us",
    LEGAL: "/cms/legal",
    HOW_TO_PLAY: "/cms/how-to-play",
    TERM_OF_USE: "/cms/term-of-use",
    CMS: "/cms/:slug",
    GAME_CMS: "/cms/:eventId/:cmsId",
  },

  EVENT: {
    LIST: "/events",
    EVENT_GAMES: "/event/:eventId",

    EVENT_GAMES_DETAILS: "/event/:eventId/:gameId",
    PLAYERS: "/players",
    PERFORMANCE: "/performance",
    LEADERBOARD: "/leaderboard",
  },
};

export const API_URL = {
  USER: {
    LOGIN: `${API_BASE_URL}login`,
    LOGIN_WITH_OTP: `${API_BASE_URL}login-with-otp`,
    LOGIN_WITH_EMAIL: `${API_BASE_URL}login-with-email`,
    FORGOT_PASSWORD: `${API_BASE_URL}password/email`,
    RESET_PASSWORD: `${API_BASE_URL}reset-password`,
    REGISTRATION: `${API_BASE_URL}register`,
    LOGOUT: `${API_BASE_URL}auth/logout`,
    DETAILS: `${API_BASE_URL}init`,
    UPDATE_PROFILE: `${API_BASE_URL}users/update`,
    UPDATE_DISPLAY_NAME: `${API_BASE_URL}users/update-dispaly-name`,
    CHECK_VALID_TOKEN: `${API_BASE_URL}check-valid-token`,
    REGISTRATION_FIELDS: `${API_BASE_URL}registraton-fields`,
  },
  EVENT: {
    GET_EVENT_LIST: `${API_BASE_URL}inside-rodeo/events`,
    GET_EVENT_GAME_LIST: `${API_BASE_URL}inside-rodeo/games`,
    GET_SPONSORS_LIST: `${API_BASE_URL}inside-rodeo/sponsors`,
    GET_GAME_DETAILS: `${API_BASE_URL}get-game-list-details`,

    GET_UPCOMING_EVENT: `${API_BASE_URL}rodeo-race/upcoming-events`,
    GET_EVENT_GAME_DETAILS: `${API_BASE_URL}rodeo-race/rodeo-event/event-details`,
    JOIN_EVENT_GAME: `${API_BASE_URL}rodeo-race/rodeo-event/join`,
    LEADERBOARD: `${API_BASE_URL}inside-rodeo/point-leaderboard`,
    GET_MENUS: `${API_BASE_URL}inside-rodeo/get-menus`,
  },
  CMS: {
    GET_CMS: `${API_BASE_URL}rodeo-race/get-cms`,
    GET_GAME_CMS: `${API_BASE_URL}get-game-cms`,
  },
  COMMON: {
    GENDER_LIST: `${API_BASE_URL}genders`,
    COUNTRY_LIST: `${API_BASE_URL}country/list`,
    SECRET_QUESTION_LIST: `${API_BASE_URL}secret/questions`,
  },
};

export const ACTIONS = {
  LOADER: {
    SET_FP_STATUS: "ACTIONS/LOADER/SET_FP_STATUS",
  },
  GLOBAL: {
    SET_LOGIN_MODAL: "ACTIONS/GLOBAL/SET_LOGIN_MODAL",
  },
  USER: {
    LOGIN: "ACTIONS/USER/LOGIN",
    LOGIN_WITH_OTP: "ACTIONS/USER/LOGIN_WITH_OTP",
    ME: "ACTIONS/USER/ME",
    SOCKET_INSTANCE_CONTAINER: "ACTIONS/USER/SOCKET_INSTANCE_CONTAINER",
    LOGOUT: "ACTIONS/USER/LOGOUT",
    UPDATE_DISPLAY_NAME: "ACTIONS/USER/UPDATE_DISPLAY_NAME",
  },
  EVENT: {
    GET_GAME_DETAILS: "ACTIONS/EVENT/GET_GAME_DETAILS",
    GET_EVENT_GAME: "ACTIONS/EVENT/GET_EVENT_GAME",
    GET_EVENT_GAME_DETAILS: "ACTIONS/EVENT/GET_EVENT_GAME_DETAILS",
    GET_STATUS_MESSAGE: "ACTIONS/EVENT/GET_STATUS_MESSAGE",
    GAME_LOGIN_REQUIRED: "ACTIONS/EVENT/GAME_LOGIN_REQUIRED",
    LEADERBOARD: "ACTIONS/EVENT/LEADERBOARD",
    //SOCKET
    GET_SOCKET_START_DATA_AND_PUSH_TO_GAME_LIST: "ACTIONS/EVENT/GET_SOCKET_START_DATA_AND_PUSH_TO_GAME_LIST",
    GET_SOCKET_START_DATA_AND_PUSH_TO_GAME_DETAILS: "ACTIONS/EVENT/GET_SOCKET_START_DATA_AND_PUSH_TO_GAME_DETAILS",
    GET_SOCKET_STATUS_MESSAGE_AND_PUSH_TO_STATUS_LIST:
      "ACTIONS/EVENT/GET_SOCKET_STATUS_MESSAGE_AND_PUSH_TO_STATUS_LIST",
    CMS_LIST: "ACTIONS/EVENT/CMS_LIST",
  },
};

export const SAGA_ACTIONS = {
  USER: {
    LOGIN: "SAGA_ACTIONS/USER/LOGIN",
    LOGIN_WITH_OTP: "SAGA_ACTIONS/USER/LOGIN_WITH_OTP",
    LOGIN_WITH_EMAIL: "SAGA_ACTIONS/USER/LOGIN_WITH_EMAIL",
    REGISTRATION: "SAGA_ACTIONS/USER/REGISTRATION",
    FORGOT_PASSWORD: "SAGA_ACTIONS/USER/FORGOT_PASSWORD",
    RESET_PASSWORD: "SAGA_ACTIONS/USER/RESET_PASSWORD",
    LOGOUT: "SAGA_ACTIONS/USER/LOGOUT",
    DETAILS: "SAGA_ACTIONS/USER/DETAILS",
    UPDATE_PROFILE: "SAGA_ACTIONS/USER/UPDATE_PROFILE",
    UPDATE_DISPLAY_NAME: "SAGA_ACTIONS/USER/UPDATE_DISPLAY_NAME",
    CHECK_VALID_TOKEN: "SAGA_ACTIONS/USER/CHECK_VALID_TOKEN",
    REGISTRATION_FIELDS: "SAGA_ACTIONS/USER/REGISTRATION_FIELDS",
  },
  EVENT: {
    GET_EVENT_LIST: "SAGA_ACTIONS/EVENT/GET_EVENT_LIST",
    GET_EVENT_GAME_LIST: "SAGA_ACTIONS/EVENT/GET_EVENT_GAME",
    GET_SPONSORS_LIST: "SAGA_ACTIONS/EVENT/GET_SPONSORS_LIST",

    GET_UPCOMING_EVENT: "SAGA_ACTIONS/EVENT/GET_UPCOMING_EVENT",
    GET_EVENT_GAME_DETAILS: "SAGA_ACTIONS/EVENT/GET_EVENT_GAME_DETAILS",
    JOIN_EVENT_GAME: "SAGA_ACTIONS/EVENT/JOIN_EVENT_GAME",
    LEADERBOARD: "SAGA_ACTIONS/EVENT/LEADERBOARD",
    GET_MENUS: "SAGA_ACTIONS/EVENT/GET_MENUS",
    GET_GAME_DETAILS: "SAGA_ACTIONS/EVENT/GET_GAME_DETAILS",
  },
  CMS: {
    GET_CMS: "SAGA_ACTIONS/COMMON/GET_CMS",
    GET_GAME_CMS: "SAGA_ACTIONS/EVENT/GET_GAME_CMS",
  },
  COMMON: {
    GENDER_LIST: "SAGA_ACTIONS/COMMON/GENDER_LIST",
    COUNTRY_LIST: "SAGA_ACTIONS/COMMON/COUNTRY_LIST",
    SECRET_QUESTION_LIST: "SAGA_ACTIONS/COMMON/SECRET_QUESTION_LIST",
  },
};

export * from "./site_statics";
export * from "./site_urls";
export * from "./functions";
export * from "./canvasUtils";
export * from "./card_utils";
